<template>
  <div class="project">

    <img class="pao pao1 wow" src="@/assets/project1.png">
    <div class="pao pao2 wow slideInLeft"></div>
    
    <myMenu :type="2" @zoomChange="initWow"></myMenu>
    <div class="project_content">
      <div class="linear_word">{{ typeNameEn }}</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">{{ typeName }}</div>
      </div>
      <div class="wow fadeInLeft">
        <div class="welcome" :class="'welcome' + (k + 1)" v-for="(v, k) in typeWelcome" :key="k">{{ v }}</div>
      </div>
      <div class="more" @click="openTicket" v-if="type != 1">
        立即购票
        <span></span>
      </div>
      <div style="height:100px;position: relative;">
        <div class="drops">
          <div class="drop wow" :data-wow-delay="dropFilter(k)" data-wow-offset="-100000" v-for="(v, k) in 16" :key="k"></div>
        </div>
      </div>
      <div class="swiper1_main wow fadeInRight">
        <div class="swiper1_main_dec" :data-wow-duration="speed / 2 + 's'">
          <div class="name">
            {{ swiper1List[activitieIndex].name }}
            <svg viewBox="0 0 100 100" class="ring ring_active">
              <path class="ring_path" d="
                M 50 50
                m 0 -37
                a 37 37 0 1 1 0 74
                a 37 37 0 1 1 0 -74
                " stroke="#feab6f" fill="none" stroke-width="25">
              </path>
            </svg>
          </div>
          <div class="dec">{{ swiper1List[activitieIndex].dec }}</div>
        </div>
      </div>
      <div class="swiper-container swiper-container1 swiper-no-swiping wow" data-wow-offset="-100000">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(v, k) in swiper1List" :key="k">
            <div class="slide-inner" :style="`background-image: url(${v.pic});`"></div>
          </div>
        </div>
      </div>
      <div class="activities_list">
        <div class="wrapper" ref="wrapper" :style="{
					left: activitieLeft + 'px'
				}">
          <div class="activities_item wow" data-wow-offset="-100000" :data-wow-delay="k * 0.3 + 's'" v-for="(v, k) in swiper2List" :key="k" :data-index="k" :class="{
						['activities_item' + (k + 1)]: true,
					}">
            <div class="img" :style="`background-image: url(${v.pic});`"></div>
            <div class="name">{{ v.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <myBottom></myBottom>
  </div>
</template>

<script>
import myMenu from '@/components/myMenu.vue'
import myBottom from '@/components/myBottom.vue'

import "wowjs/css/libs/animate.css";
import "@/assets/css/wowExtra.css";
import { WOW } from 'wowjs'

import Swiper from '@/tools/swiper.js'
import "@/assets/css/swiper.css";
export default {
  components: { myMenu, myBottom },
  data() {
    return {
      type: 1,
      typeNameEn: '',
      typeName: '',
      typeWelcome: [],
      mySwiper1: '',
      swiper1List: [
        {
          pic: require('@/assets/project_s1_1.png'),
          name: '重返地球',
          dec: '动感环幕影院《重返地球》，带领游客进入熊出没大电影《熊出没·重返地球》的神奇科幻世界，开启一段身临其境、惊险刺激的探险之旅。'
        },
        {
          pic: require('@/assets/project_s1_2.png'),
          name: '玩具屋大冒险',
          dec: '室内轨道游览车项目《玩具屋大冒险》，游客们将乘坐轨道车，加入“熊熊帮帮团”的队伍，在光头强的神奇玩具屋进行一场奇妙的微缩世界闯关之旅。'
        },
        {
          pic: require('@/assets/project_s1_3.png'),
          name: '寻梦剧场',
          dec: '标准主题剧场，在演绎熊出没系列动人故事的同时，也将不定期举办大型活动庆典，全年轮番上演精彩节目。'
        },
        {
          pic: require('@/assets/project_s1_4.png'),
          name: '熊熊乐园',
          dec: '以“熊出没”为主题打造的室内儿童探险乐园，让小朋友在“熊出没”的世界中尽情玩乐，收获勇气和快乐。'
        },
        {
          pic: require('@/assets/project_s1_5.png'),
          name: '港湾影城',
          dec: '以“熊出没”主题包装的影院，让游客重温有熊出没陪伴的美好时光。'
        },
        {
          pic: require('@/assets/project_s1_6.png'),
          name: '天空之眼',
          dec: '坐上宁波浪漫新地标“天空之眼”摩天轮，俯瞰乐园美景，记录幸福和浪漫的瞬间。 '
        },
        {
          pic: require('@/assets/project_s1_7.png'),
          name: '飞行家挑战基地',
          dec: '利用空气动力学的原理，让游客体验失重的感觉，感受飞翔的刺激，体会只有万米高空跳伞时才能感受到的空中飞行、自由落体之快感。'
        },
        {
          pic: require('@/assets/project_s1_8.png'),
          name: '疯狂碰碰车',
          dec: '驾驶小赛车在赛场上驰骋，欢乐碰撞，尽情狂欢。'
        },
        {
          pic: require('@/assets/project_s1_9.png'),
          name: '欢乐跳跳',
          dec: '加入舞蹈派对，一起欢乐升降旋转，蹦蹦跳跳。'
        },
        {
          pic: require('@/assets/project_s1_10.png'),
          name: '宝贝探险营',
          dec: '进入《熊出没·奇幻空间》的神奇世界开启丛林探险，在攀爬、滑行、钻筒、走梯、荡秋千等充满乐趣的游乐设施里探索自然。'
        },
      ],
      activitieIndex: 0,
      activitieLeft: 0,
      activitieAnimating: false,
      swiper2List: [],
      temporarySlide: {},
      speed: 1,
    }
  },
  methods: {
    openTicket() {
        $('.ticketOpen').addClass('myPopup_box_show')
    },
    // 探险乐园，水上乐园
    setType(type) { 
      this.type = type;
      if (type != 2) {
        $('.ticketOpen').removeClass('ticketOpenWaterPark')
        this.typeNameEn = 'COMMERCIAL STREET';
        this.typeName = '开放式主题街区';
        this.typeWelcome = ['开放式主题街区以《熊出没》IP为创意打造了十余个熊出没主题项目，并拥有港湾影城、港湾美食街、电玩城、飞行家挑战基地、VR体验馆、婚纱摄影馆、梦境水岸、青创基地、咖啡馆、特色民宿等数十种业态服务，集吃、住、游、购、娱于一体，全天候营业，为游客带来休闲娱乐新体验。'];
      } else {
        $('.ticketOpen').addClass('ticketOpenWaterPark')
        this.typeNameEn = 'WATERPARK ';
        this.typeName = '熊出没水上乐园';
        this.typeWelcome = ['熊出没水上乐园是由华强方特以熊出没大电影《熊出没·原始时代》为创意背景打造的水上主题乐园。乐园拥有四大特色水上项目及多项特色造景：真实模拟海洋冲浪的《飓风湾》，拥有多种模式的波浪冲击，可尽情体验大海的汹涌澎湃；《熊出没水寨》融合熊出没元素打造了多款适合儿童及亲子互动的家庭戏水项目，是孩子们的嬉水天地；还有《欢乐滑道》《大喇叭》等项目及一系列丰富精彩的水上表演和互动活动，为广大游客带来清凉酷爽的合家欢游乐体验。', ];
        this.swiper1List = [
          {
            pic: require('@/assets/project_s2_1.png'),
            name: '飓风湾',
            dec: '《飓风湾》拥有真实模拟海上巨浪的“真空造浪池”，您可以感受从不同方向冲击而来的刺激巨浪，尽情体验浪花强力冲击的清凉快感。'
          },
          {
            pic: require('@/assets/project_s2_2.png'),
            name: '熊出没水寨',
            dec: '以熊出没为主题的家庭戏水项目，《熊出没水寨》设有水枪对战区、水上浮桥、水炮喷淋区等多种戏水区域，为您开启合家嬉水的欢愉时光。'
          },
          {
            pic: require('@/assets/project_s2_3.png'),
            name: '欢乐滑道',
            dec: '从六条起伏跌宕的彩色竞速滑道直冲池底，体验风驰电掣的加速快感。'
          },
          {
            pic: require('@/assets/project_s2_4.png'),
            name: '大喇叭',
            dec: '高空巨型喇叭滑道，从高处快速滑落，在巨大的喇叭口中盘旋、加速、冲刺，体验180度极速旋转带来的海上龙卷风之旅。'
          },
        ];
      }
      this.swiper2List = JSON.parse(JSON.stringify(this.swiper1List));
    },
    dropFilter(k) {
      var row = Math.floor(k % 4);
      var col = Math.floor(k / 4);
      var time = (col > row ? col : row) * 0.1;
      return time + 's';
    },
    activitieChange(el) {
      let realIndex = $(el).attr('data-index');
      if (this.activitieAnimating || realIndex == this.activitieIndex) {
        return;
      }
      this.activitieAnimating = true;
      $('.activities_item').removeClass('activities_item_active');
      $(el).addClass('activities_item_active');
      var prevDom = $(el).prevAll();
      this.activitiesControl(prevDom.length, realIndex);
      if (this.swiper1List.length > 4) {
        setTimeout(() => {
          this.$refs.wrapper.style.transition = `all 0s`;
          for (let i = prevDom.length - 1; i >= 0; i--) {
            $('.activities_list .wrapper').append(prevDom.eq(i).clone(true));
          }
          prevDom.remove();
          this.activitieLeft = 0;
          this.activitieAnimating = false;
        }, this.speed * 1000);
      }
    },
    activitiesControl(index, realIndex) {
      let activitieIndex = this.activitieIndex;
      $(".swiper1_main_dec").removeClass('fadeInUp');
      $(".swiper1_main_dec").addClass('fadeOutDown animated');
      $(".ring").removeClass('ring_active');
      setTimeout(() => {
        $(".ring").addClass('ring_active');
        $(".swiper1_main_dec").removeClass('fadeOutDown');
        $(".swiper1_main_dec").addClass('fadeInUp animated');
        this.activitieIndex = realIndex;
      }, this.speed * 500);
      this.$refs.wrapper.style.transition = `all ${this.speed}s`;
      if (this.swiper1List.length > 4) {
        let left = this.activitieLeft + index * 344 * -1;
        this.activitieLeft = left;
      }
      let temporaryIndex = realIndex > 0 ? realIndex - 1 : this.swiper1List.length - 1;
      Object.assign(this.temporarySlide, this.swiper1List[temporaryIndex]);
      Object.assign(this.swiper1List[temporaryIndex], this.swiper1List[activitieIndex]);
      this.mySwiper1.slideToLoop(temporaryIndex, 0);
      setTimeout(() => {
        this.mySwiper1.slideNext();
        setTimeout(() => {
          if (this.temporarySlide.pic) {
            Object.assign(this.swiper1List[temporaryIndex], this.temporarySlide);
            this.swiper1List[temporaryIndex] = this.temporarySlide;
            this.temporarySlide = {}
          }
          if (this.swiper1List.length <= 4) {
            this.activitieAnimating = false;
          }
        }, this.speed * 1000);
      }, 0);
    },
    initSwiper() {
      var interleaveOffset = 0.5; //视差比值
      this.mySwiper1 = new Swiper('.swiper-container1', {
        loop: true,
        speed: this.speed * 1000,
        watchSlidesProgress: true,
        on: {
          progress: function (swiper) {
            for (var i = 0; i < swiper.slides.length; i++) {
              var slideProgress = swiper.slides[i].progress;
              var innerOffset = swiper.width * interleaveOffset;
              var innerTranslate = slideProgress * innerOffset + 1;
              swiper.slides[i].querySelector(".slide-inner").style.transform =
                "translate3d(" + innerTranslate + "px, 0, 0)";
            }
          },
          setTransition: function (swiper, speed) {
            for (var i = 0; i < swiper.slides.length; i++) {
              swiper.slides[i].style.transition = speed + "ms";
              swiper.slides[i].querySelector(".slide-inner").style.transition =
                speed + "ms";
            }
          }
        }
      });
    },
    setWow() {
      $('.swiper-container1').css('transform', 'translate(-20000px, 0)');
      $('.activities_list').css('transform', 'translate(-20000px, 0)');
      $('.pao1').css('transform', 'translate(-20000px, 0)');
      $('.drops').css('transform', 'translate(-20000px, 0)');
    },
    initWow(zoom) {
      var top = $('.activities_item').eq(1).offset().top;
      var offset = zoom >= 1 ? 200 * zoom : (200 * zoom - (top - top * zoom));
      var wow = new WOW(
        {
          animateClass: 'animated',
          offset,
          callback: box => {
            if (box.className.includes('swiper1_main')) {
              $('.swiper-container1').css('transform', 'translate(0, 0)');
              $('.swiper-container1').addClass('fadeInLeft');

              $('.activities_list').css('transform', 'translate(0, 0)');
              $('.activities_item').addClass('slideInRightLittle');
              setTimeout(() => {
                $('.activities_item' + (this.activitieIndex + 1)).addClass('activities_item_active');
              }, 1200);

              $('.drops').css('transform', 'translate(0, 0)');
              $('.drops .drop').addClass('zoomIn');

              $('.pao1').css('transform', 'translate(0, 0)');
              $('.pao1').addClass('rotateInDownLeftLittle');
            }
            $(box).removeClass('wow');
          }
        }
      );
      wow.init();
    },
  },
  created() {
    this.setType(this.$route.meta.type);
  },
  mounted() {
    let that = this;
    $(function () {
      $('.activities_item').click(function () {
        that.activitieChange(this);
      });
    })
    this.setWow();;
    this.initSwiper();
  }
}
</script>

<style lang="scss" scoped>
.project {
  .project_content {
    width: 1320px;
    margin: 110px auto 100px;
    position: relative;
    z-index: 1;
    .welcome {
      font-size: 26px;
      text-indent: 2em;
      width: 1000px;
      line-height: 46px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
    .welcome1 {
      margin-top: 40px;
    }
    .swiper-container1 {
      margin-left: 0;
      width: 730px;
      height: 470px;
      overflow: hidden;
      border-radius: 20px;
      .swiper-slide {
        background-color: #eee;
        text-align: center;
        font-size: 18px;
        overflow: hidden;
        .slide-inner {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          background-size: cover;
          background-position: center;
          display: -webkit-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          -webkit-justify-content: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          -webkit-align-items: center;
          align-items: center;
          color: #fff;
        }
      }
      .swiper-slide-active+.swiper-slide{  // 防止右边漏边
        opacity: 0;
      }
    }
    .swiper1_main {
      float: right;
      width: 530px;
      margin-top: 170px;
      .ring {
        width: 40px;
        height: 40px;
        display: inline-block;
        position: relative;
        .ring_path {
          transition: stroke-dasharray 0.5s ease;
          stroke-dasharray: 0, 232.478px;
          stroke-dashoffset: 0px;
        }
      }
      .ring_active {
        .ring_path {
          stroke-dasharray: 232.478px, 232.478px;
        }
      }
      .name {
        font-size: 48px;
        color: #3445a0;
        font-weight: bold;
        line-height: 100px;
      }
      .dec {
        font-size: 26px;
        line-height: 50px;
        color: #000000;
        text-indent: 2em;
      }
    }
    .activities_list {
      width: 1700px;
      height: 400px;
      white-space: nowrap;
      position: relative;
      overflow: hidden;
      margin-left: -16px;
      .wrapper {
        padding-top: 70px;
        position: absolute;
        left: 0;
        top: 0;
        padding-left: 16px;
      }
      .activities_item {
        border-radius: 20px;
        background-color: rgb(255, 255, 255);
        box-shadow: 0px 14px 32px 0px rgba(148, 161, 190, 0.16);
        width: 324px;
        padding: 22px;
        box-sizing: border-box;
        transition: all 1s;
        transform: translate(0, 0);
        display: inline-block;
        margin-right: 20px;
        cursor: pointer;
        .img {
          border: 1px solid #fff;
          border-radius: 10px;
          box-shadow: 0px 6px 16px 0px rgba(148, 161, 190, 0.3);
          height: 181px;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }
        .name {
          font-size: 32px;
          color: #2f2f2f;
          margin-top: 24px;
          text-align: center;
          transition: all .3s;
        }
      }
      .activities_item_active {
        transform: translate(0, -20px);
        cursor: auto;
        .name{
          color: #f67926;
        }
      }
    }
  }
  .pao1 {
    top: 956px;
    left: 1160px;
  }
  .pao2 {
    border-radius: 50%;
    background-image: -moz-linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    background-image: -webkit-linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    background-image: -ms-linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    background-image: linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    opacity: 0.6;
    left: -135px;
    top: 1252px;
    width: 239px;
    height: 239px;
  }
  .drops {
    position: absolute;
    left: 740px;
    top: 130px;
    width: 120px;
    font-size: 0;
    .drop {
      width: 9px;
      height: 9px;
      background: #ffa147;
      border-radius: 50%;
      display: inline-block;
      margin-right: 18px;
      margin-bottom: 18px;
    }
  }
}
.more {
  transition: all 0.4s;
  width: 203px;
  height: 52px;
  text-align: center;
  line-height: 52px;
  border-radius: 999px;
  background: rgb(234, 94, 62);
  background: -moz-linear-gradient(
    30deg,
    rgb(234, 94, 62) 0%,
    rgb(253, 148, 36) 100%
  );
  background: -webkit-linear-gradient(
    30deg,
    rgb(234, 94, 62) 0%,
    rgb(253, 148, 36) 100%
  );
  background: -o-linear-gradient(
    30deg,
    rgb(234, 94, 62) 0%,
    rgb(253, 148, 36) 100%
  );
  background: -ms-linear-gradient(
    30deg,
    rgb(234, 94, 62) 0%,
    rgb(253, 148, 36) 100%
  );
  background: linear-gradient(
    120deg,
    rgb(234, 94, 62) 0%,
    rgb(253, 148, 36) 100%
  );
  color: #fff;
  font-size: 24px;
  letter-spacing: 3px;
  text-indent: 3px;
  cursor: pointer;
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 36px;
  -webkit-box-shadow: 0px 3px 10px 0px rgba(230, 132, 26, 0.38);
  -moz-box-shadow: 0px 3px 10px 0px rgba(230, 132, 26, 0.38);
  box-shadow: 0px 3px 10px 0px rgba(230, 132, 26, 0.38);
  span {
    display: inline-block;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    color: #fd9424;
    font-size: 0;
    font-weight: bold;
    transition: all 0.4s;
    margin-left: 0;
    transform: translate(14px, 0) scale(0);
    transform-origin: left center;
    background: #fff url('~@/assets/arrow10.png') no-repeat;
    background-size: 18px auto;
    background-position: center center;
  }
  &:hover {
    padding-left: 0;
    span {
      opacity: 1;
      transform: translate(14px, 0) scale(1);
    }
  }
}
</style>